import { HTTPService as Srv } from '@services';

export const $product_save = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{
		name = '' || null,
		symbol = '' || null,
		type = '' || null,
		buyprice = 0 || null,
		sellprice = 0 || null,
		innerbuyprice = 0 || null,
		innersellprice = 0 || null,
		orderNumber = 0 || null,
		isVisible = '' || null,
		isHead = '' || null,
		...body
	}, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('product/save', {
				name,
				symbol,
				type,
				isVisible,
				isHead,
				buyprice,
				sellprice,
				innerbuyprice,
				innersellprice,
				orderNumber,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $product_edit = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{
		id = '' || null,
		name = '' || null,
		symbol = '' || null,
		type = '' || null,
		isVisible = '' || null,
		isHead = '' || null,
		buyprice = 0 || null,
		sellprice = 0 || null,
		innerbuyprice = 0 || null,
		orderNumber = 0 || null,
		code = 0 || null,
		...body
	}, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('product/edit', {
				id,
				name,
				symbol,
				type,
				isVisible,
				isHead,
				buyprice,
				sellprice,
				innerbuyprice,
				orderNumber,
				code,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $product_delete = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ id = 0 || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('product/delete', {
				id,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $product_fetch_all = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ type = '' || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('product/fetch/all', {
				type,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $product_fetch_all_archive = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ id = 0 || null, from = 0 || null, to = 0 || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('product/fetch/all/archive', {
				id,
				from,
				to,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $product_fetch_id = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ id = 0 || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('product/fetch/id', {
				id,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $product_fetch_type = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ type = '' || null, isUpdated = null || false, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('product/fetch/type', {
				type,
				isUpdated,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $product_fetch_mainboard = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ type = '' || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('product/fetch/mainboard', {
				type,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $product_calculator = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ currency1 = '' || null, currency2 = '' || null, count = '' || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('product/calculator', {
				currency1,
				currency2,
				count,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $product_fetch_archive = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ symbol = null, period = null, fromDate = null, toDate = null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('product/fetch/archive', {
				symbol,
				period,
				fromDate,
				toDate,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});
